<template>
  <div class="box box_v" style="height: 100%">
    <div class="mini-header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="goback"></div>
      </div>
      <div class="mini-header">业主委员会公告</div>
      <div class="addManager">
        <Button v-if="$route.query.id" class="bkcc-btn" @click="fabu(1)">保存</Button>
        <Button v-else class="bkcc-btn" @click="fabu(2)">发布</Button>
      </div>
    </div>
    <div class="item-wrapper box box_f1">
      <Card style="width: 100%;margin-right: 20px;margin-bottom: 20px" class="card">
        <Form :model="gonggao" :label-width="80" style="font-size: 18px">
          <FormItem label="封面图">
            <upload-img
              :imgArr="imgArr"
              :imgNumber="imgNumber"
              :fixedNumber="fixedNumber"
              :imgHeight="148"
              :imgWidth="238"
              @saveImg="saveImg"
              @delPic="delPic"
              :isActive="isActive"
            >
              <div class="uploadbox">
                <i class="iconfont icon-shangchuan1"></i>
                <p class="fengmian">请上传封面</p>
                <p class="tips">注意图片尺寸为：2:1</p>
              </div>
            </upload-img>
          </FormItem>
          <FormItem label="标题">
            <Input placeholder="请输入标题" v-model="gTitle" :maxlength="32" style="width: 970px" />
          </FormItem>
          <FormItem label="正文">
            <editor-box
              :content="gonggao.content"
              @editorContent="activityContent"
              :height="editorHeight"
              width="970px"
              style="width: 970px;margin-top: 11px"
            ></editor-box>
          </FormItem>
        </Form>
      </Card>
      <Spin fix v-if="loading"></Spin>
    </div>
  </div>
</template>

<script>
import editorBox from "../../../components/editorBox";
import uploadImg from "../../../components/uploadImg";
export default {
  components: {
    editorBox,
    uploadImg,
  },
  name: "ownCommitteeDetail",
  data() {
    return {
      zoneId: this.$route.query.zoneId,
      gonggao: {
        pic: "",
        content: "",
      },
      imgNumber: 1,
      imgArr: [],
      fixedNumber: [2, 1],
      isActive: false,
      editorHeight: "320px",
      isTableLoading: false,
      gTitle: "",
      loading: false,
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    saveImg(data) {
      this.imgArr.splice(0, 1, data);
      this.isActive = true;
    },
    delPic() {
      this.imgArr = [];
    },
    activityContent(data) {
      this.gonggao.content = data;
    },
    fabu(status) {
      this.loading = true;
      let data = {
        title: this.gTitle,
        context: this.gonggao.content,
        coverPicUrl: this.imgArr.length ? this.imgArr[0].path : "",
      };
      if (this.$route.query.id) {
        data.id = this.$route.query.id;
      }
      console.log(data);
      this.$post(this.urlobj.addOwnCommitteeNotice(this.zoneId), data)
        .then((res) => {
          var mText = status == 2 ? "发布成功" : "保存成功";
          if (res.isSucceed) {
            this.loading = false;
            this.$Message.success(mText);
            this.$router.go(-1);
          }
        })
        .catch((e) => {
          if (e.data.code == 900130) {
            this.loading = false;
          }
          this.loading = false;
        });
    },
    getNotice() {
      this.$get(this.urlobj.getNoticeDetail(this.$route.query.id)).then(
        (res) => {
          if (res.isSucceed) {
            console.log(res);
            if (res.rows && res.rows[0]) {
              let info = res.rows[0];
              this.gTitle = info.title;
              this.imgArr.push({ id: 0, path: info.coverPicUrl });
              this.gonggao.content = info.context;
            }
          } 
        }
      );
    },
  },
  mounted() {},
  created() {
    if (this.$route.query.id) {
      this.getNotice();
    }
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}

.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}

.mini-header-wrapper {
  display: flex;
  /*height: 30px;*/
  line-height: 30px;
  padding: 30px 0;
  justify-content: center;
  position: relative;
}

.mini-header {
  font-size: 25px;
  text-align: center;
}

.item-wrapper {
  padding-left: 20px;
}

.newvote {
  position: absolute;
  right: 20px;
  button {
    width: 80px;
    height: 28px;
    line-height: 13px;
  }
  .btn-dc {
    background-color: #ff7c43;
    border-color: #ff7c43;
  }
}

/deep/ .ivu-input {
  font-size: 18px;
  padding: 20px;
}

/deep/ .ivu-input-wrapper {
  margin-top: 11px;
}

/deep/ .ivu-form-item-label {
  font-size: 18px;
}

/deep/ .card .ivu-radio-wrapper {
  font-size: 18px;
  color: #999;
}

/deep/ .isActive {
  margin-top: 12px;
  margin-left: -268px;
}

/deep/ .imgbox {
  margin-top: 12px;
}

.uploadbox {
  width: 238px;
  height: 148px;
  border: 1px dashed #ddd;
  text-align: center;
  margin-top: 12px;
  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
    color: #e3e3e3;
    margin-top: 32px;
  }
  .fengmian {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
  }
  .tips {
    font-size: 14px;
    color: #999;
  }
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.addManager {
  position: absolute;
  right: 20px;
  display: flex;
  align-items: center;
}
</style>
